export const UserRole = {
  ADMIN: 'ADMIN',
  USER: 'USER',
  UNKNOWN: 'UNKNOWN',
};

export const UserEditStatus = {
  NEW: 'NEW',
  EDIT_SELF: 'EDIT_SELF',
  EDIT_OTHER: 'EDIT_OTHER',
  NONE: 'NONE',
};

export const getUserRole = (user, activeUgId) => {
  const activeCompany = (user.companies.find((c) => (c.id === activeUgId)) || {});
  const role = ((activeCompany.role || {}).name || '');
  return (role || UserRole.UNKNOWN).toUpperCase();
};
